import { Button, Form } from 'antd';
import { FormInstance } from 'antd/es/form';
import { MaskedInput } from '@/components';
import { StyledFormWrapper } from './UserDataFormStyles';
import { DATE_MASK_MAX_DIGITS, formatDateOfBirthMask, formatPhoneMask, PHONE_MASK_MAX_DIGITS, stripPhoneCountryCode } from '@/utils';
import { isFieldValueValid, TFieldErrors, TUserDataFormValues, UserDataFormFields } from '../../helpers';
import { useGetFormValidations } from '../../hooks';

type TUserDataFormProps = {
  form: FormInstance<TUserDataFormValues>;
  initialValues?: TUserDataFormValues;
  loading?: boolean;
  onSubmit?: (data: TUserDataFormValues) => void;
  fieldErrors?: TFieldErrors;
}

const UserDataForm = ({ form, initialValues, loading, onSubmit, fieldErrors }: TUserDataFormProps) => {
  const rules = useGetFormValidations();

  const phoneValue = Form.useWatch(UserDataFormFields.PHONE, form);
  const birthdateValue = Form.useWatch(UserDataFormFields.BIRTHDATE, form);

  const getFieldStatus = (field: UserDataFormFields, value?: string) =>
    fieldErrors?.[field] && !isFieldValueValid(field, value) ? 'error' : undefined;

  return (
    <StyledFormWrapper>
      <Form form={form} layout='vertical' onFinish={onSubmit} initialValues={initialValues}>
        <Form.Item
          name={UserDataFormFields.PHONE}
          label="Ваш телефон"
          rules={rules[UserDataFormFields.PHONE]}
          validateStatus={getFieldStatus(UserDataFormFields.PHONE, phoneValue)}
        >
          <MaskedInput
            format={formatPhoneMask}
            maxDigits={PHONE_MASK_MAX_DIGITS}
            placeholder="+380 (__) ___-__-__"
            inputMode="tel"
            size="large"
            normalizeDigits={stripPhoneCountryCode}
          />
        </Form.Item>
        <Form.Item
          name={UserDataFormFields.BIRTHDATE}
          label="Дата народження"
          rules={rules[UserDataFormFields.BIRTHDATE]}
          validateStatus={getFieldStatus(UserDataFormFields.BIRTHDATE, birthdateValue)}
        >
          <MaskedInput
            format={formatDateOfBirthMask}
            maxDigits={DATE_MASK_MAX_DIGITS}
            placeholder="__.__.____"
            inputMode="numeric"
            size="large"
          />
        </Form.Item>
        <Button block size='large' type="primary" htmlType="submit" loading={loading} disabled={loading}>Зберегти</Button>
      </Form>
    </StyledFormWrapper>
  );
}

export default UserDataForm;
